/**
 * useUsernameAvailability — live username availability for the signup form.
 *
 * Dormant on purpose: the check this is built around, `GET
 * /api/v1/UserProfile/CheckUsername?userName=`, does not exist on any API host
 * yet (it answers 404, and anonymous signup has no other endpoint that can tell
 * a name apart). Asking anyway only showed "Checking availability…" and disabled
 * Continue for one round trip before falling back to `idle`, so the request is
 * gone and the hook reports `idle` until the endpoint ships. The format rule on
 * the field plus the duplicate-name error the server returns on submit are what
 * guard the username in the meantime.
 *
 * To switch it back on: add the path to `API_ENDPOINTS.REGISTRATION`, then
 * debounce the field and set `checking` / `available` / `taken` from the
 * response here. The status line and its styles in `auth.css` already render all
 * three states, and an API failure must resolve to `idle` so a signup is never
 * blocked by this check.
 */
export type UsernameAvailabilityStatus = 'idle' | 'checking' | 'available' | 'taken';

export function useUsernameAvailability(
  _username: string,
): { status: UsernameAvailabilityStatus } {
  return { status: 'idle' };
}
